module.exports = __webpack_public_path__ + "static/media/step2.9aec0849.jpeg";